import carousel_1 from "./home_hero_carousel_mobile_1.webp";
import carousel_2 from "./home_hero_carousel_mobile_2.webp";
import carousel_3 from "./home_hero_carousel_mobile_3.webp";
import carousel_4 from "./home_hero_carousel_mobile_4.webp";
import carousel_5 from "./home_hero_carousel_mobile_5.webp";
import carousel_6 from "./home_hero_carousel_mobile_6.webp";
import carousel_7 from "./home_hero_carousel_mobile_7.webp";
import carousel_8 from "./home_hero_carousel_mobile_8.webp";
import carousel_9 from "./home_hero_carousel_mobile_9.webp";
import carousel_10 from "./home_hero_carousel_mobile_10.webp";
import carousel_11 from "./home_hero_carousel_mobile_11.webp";
import carousel_12 from "./home_hero_carousel_mobile_12.webp";
import carousel_13 from "./home_hero_carousel_mobile_13.webp";
import carousel_14 from "./home_hero_carousel_mobile_14.webp";
import carousel_15 from "./home_hero_carousel_mobile_15.webp";

// Mobile crops for Home.js's rotating hero carousel. Own, independent set
// from ../hero_carousel/carouselImages.js's carousel_images — the two no
// longer need to match in count or order, since each is maintained as its
// own real set of photos now rather than placeholder copies of the other.
export const carousel_images_mobile = [
  carousel_1,
  carousel_2,
  carousel_3,
  carousel_4,
  carousel_5,
  carousel_6,
  carousel_7,
  carousel_8,
  carousel_9,
  carousel_10,
  carousel_11,
  carousel_12,
  carousel_13,
  carousel_14,
  carousel_15,
];
